import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useTrakrServer, useXHost } from '@aftersale-next/atoms';
import { Fragment, useEffect } from 'react';
import { TRAKR_SERVER } from '../config/env';
import { getHost } from './config';
import useSetupEcommerceAtoms from './hooks/setup/use-setup-ecommerce-atoms';
import { pipethrough } from './pipethrough';
import { stripPort } from './string-utils';
export function SetupAtoms() {
  useSetupEcommerceAtoms();

  var _useTrakrServer = useTrakrServer(),
      _useTrakrServer2 = _slicedToArray(_useTrakrServer, 2),
      setServer = _useTrakrServer2[1];

  var _useXHost = useXHost(),
      _useXHost2 = _slicedToArray(_useXHost, 2),
      setXhost = _useXHost2[1];

  useEffect(function () {
    setServer(TRAKR_SERVER);

    if (true) {
      setXhost(pipethrough(getHost()).pipe(stripPort).value());
    }
  }, [setServer, setXhost]);
  return /*#__PURE__*/_jsx(Fragment, {});
}